import { dispatchTwiceGetImpactVenueCo2 } from '@/domain/impact-calculate-venue/actions/utils/dispatch-twice-get-impact-venue-co2';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { reloadMonthDeclarations } from '@/domain/project-venue-month-declaration/actions/reload-month-declaration.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getVenueDates } from './get-venue-dates.action';

type Params = { venueDateIds: number[] };

type Result = void;

export const deleteMultipleVenueDates = createAppAsyncThunk(
  'projectVenueDates/deleteMultipleVenueDates',
  async (
    params: Params,
    {
      extra: { projectVenueDatesGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      await Promise.all(
        params.venueDateIds.map((id) => projectVenueDatesGateway.delete(id)),
      );
      await dispatch(getVenueDates());
      const currentProject = selectCurrentProjectVenue(getState());
      if (currentProject) {
        dispatchTwiceGetImpactVenueCo2(dispatch, currentProject.id);
      }
      await dispatch(reloadMonthDeclarations());
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(
    translate('DeleteMultipleVenueDates.Message.success'),
  );
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteMultipleVenueDates.Message.error'));
}
